import React, { Component } from 'react';
import { Tab, Row, Col, Nav, NavItem, Modal, Button, Form, FormGroup } from 'react-bootstrap'
import {Box} from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import Item0 from './Menu0/Item'
import Item1 from './Menu1/Item'
import Item2 from './Menu2/Item'
import Item3 from './Menu3/Item'
import Item4 from './Menu4/Item'
import Item5 from './Menu5/Item'
import Item6 from './Menu6/Item'
import Item7 from './Menu7/Item'
import Item8 from './Menu8/Item'
import Item9 from './Menu9/Item'
import Item10 from './Menu10/Item'
import Item11 from './Menu11/Item'
import Item12 from './Menu12/Item'
import Item13 from './Menu13/Item'
import Item14 from './Menu14/Item'
import Item15 from './Menu15/Item'
import ItemWorkConfig from './MenuWorkConfig/Item'
import './AccountSettings.css'
import { connect } from 'react-redux'
import { Switch, Route, withRouter } from 'react-router-dom'
import AccountSettingsStore from 'stores/AccountSettingsStore'
import { Checkbox } from 'react-icheck'
import Select from 'react-select'
var NotificationSystem = require('react-notification-system')
class AccountSettings extends Component {

  constructor(props) {
    super(props)

    this.state = {
      activeKey:'/information',
      tabslist:this.initTabs(),
      showSetting:false,
      perm_settings:[],
      settings:[],
      roles:[],
      role:''
    }
  }

  componentDidMount() {
    const {activeKey} = this.state
    this.onTabsSelect(activeKey)
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
  }

  loadData() {
    AccountSettingsStore.loadPermMenu((result)=>{
      this.setState({perm_settings:this.settingConfig(result.data)})
    })
  }

  initTabs(param={show:true},param1={show:false},param2={show:false},param3={show:false},param4={show:false},param5={show:false},param6={show:false},param7={show:false},param8={show:false},param9={show:false},param10={show:false},param11={show:false},param12={show:false},param13={show:false},param14={show:false},param15={show:false}) {
    const {messages} = this.props
    const tabslist = [
      {key:0,path:'/company-divider',icon:'',title:'ข้อมูลอู่/บริษัท',disabled:true,content:<div />},
      {key:1,path:'/information',icon:'university',title:messages['Company Info'],content:<Item0 settings={param} />},
      {key:2,path:'/docnumberformat',icon:'file-text',title:messages['Doc Number Format'],content:<Item1 settings={param1} />},
      {key:3,path:'/docprintconfig',icon:'print',title:messages['Doc Print Config'],content:<Item2 settings={param2} />},
      {key:4,path:'/ssp',icon:'dashboard',title:messages['SSP'],content:<Item3 settings={param3} />},
      {key:5,path:'/wageconfig',icon:'usd',title:messages['Wage Config'],content:<Item4 settings={param4} />},
      {key:6,path:'/damageconfig',icon:'file',title:messages['Damage Config'],content:<Item11 settings={param11} />},
      {key:7,path:'/cartypeconfig',icon:'car',title:messages['Car Type Config'],content:<Item10 settings={param10} />},
      {key:19,path:'/carfixingconfig',icon:'car',title:messages['Car Fixing Config'],content:<Item15 settings={param15} />},
      {key:8,path:'/carconfig',icon:'car',title:messages['Car Config'],content:<Item8 settings={param8} />},
      {key:9,path:'/fixingconfig',icon:'wrench',title:messages['Fixing Config'],content:<Item5 settings={param5} />},
      {key:10,path:'/workconfig',icon:'file-o',title:messages['Work Config'],content:<ItemWorkConfig settings={param5} />},
      {key:11,path:'/docdownload',icon:'download',title:messages['Doc Download'],content:<Item6 settings={param6} />},
      {key:12,path:'/user-divider',icon:'',title:'ข้อมูลผู้ใช้',disabled:true,content:<div />},
      {key:13,path:'/user',icon:'user',title:messages['User'],content:<Item7 settings={param7} />},
      {key:14,path:'/usermenuconfig',icon:'list-alt',title:messages['User Menu Config'],content:<Item9 settings={param9} />},
      {key:15,path:'importmasterdata-divider',icon:'',title:'นำเข้าข้อมูล',disabled:true,content:<div />},
      {key:16,path:'/importmasterdata',icon:'download',title:'นำเข้าข้อมูลคลังสินค้า',content:<Item12 settings={param12} />},
      {key:17,path:'/importwagemasterdata',icon:'download',title:'นำเข้าข้อมูลค่าแรง',content:<Item13 settings={param13} />},
      {key:18,path:'/importcustomermasterdata',icon:'download',title:'นำเข้าข้อมูลลูกค้า',content:<Item14 settings={param14} />}
    ]
    return tabslist
  }
  
  onTabsSelect(tab) {
    this.setState({activeKey:tab})
    let path = tab              
    this.props.history.push({pathname:path,search:'',state:{}})
  }

  settingConfig(settings) {
    let {tabslist} = this.state
    let new_settings = []
    tabslist.forEach((item,index)=>{
      let findIndex = settings.findIndex(x=>x.key===item.key)
      if (findIndex!==-1) {
        item.show = settings[findIndex].show
        new_settings.push(item)
      } else {
        item.show = false
        new_settings.push(item)
      }
    })
    return new_settings
  }

  onModalSettingClick() {
    let {role,roles} = this.state
    AccountSettingsStore.loadConfigMenu(role,(result)=>{
      roles = result.roles.map((item,index)=>{
        return {label:item.name,value:item.bf_role_id}
      })
      this.setState({showSetting:true,settings:this.settingConfig(result.data),roles:roles})
    })
  }

  onRoleChange(e) {
    if (e!==null) {
        this.setState({role:e.value},()=>{
          this.onModalSettingClick()
        })
    } else {
        this.setState({role:''},()=>{
          this.onModalSettingClick()
        })
    }
  }

  onHide() {
    this.setState({showSetting:false})
  }

  onSettingSaveClick() {
    let {settings,role} = this.state
    let postData = settings
    AccountSettingsStore.saveConfigMenu(role,postData,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'บันทึกการตั้งค่าสำเร็จ',
          level:'info',
          position:'tc'
        });
        this.onHide()
        this.loadData()
      }
    },()=>{
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ไม่สามารถบันทึกการตั้งค่าได้ กรุณาลองอีกครั้ง',
        level:'error',
        position:'tc'
      });
      this.onHide()
    })
  }

  onSettingMenuCheck(index,status) {
    let {settings} = this.state
    settings[index].show = status
    this.setState({settings:settings})
  }

  renderTabs() {
    let {perm_settings} = this.state
    let {showAdminMenu} = this.props
    return(
      <Nav id="account-settings-menu" bsStyle="pills" stacked>
      {perm_settings.map((item,index)=> {
        if (item.path==='/company-divider'&&showAdminMenu) {
          return(
            <li key={index}>
              <a className='title-account-settings' id="tabs-account-settings-tab-/company-divider" href="#" style={{pointerEvents:'none'}}>
                ข้อมูลอู่/บริษัท
              </a>
              <span className="fa fa-gear pull-right" style={{cursor:'pointer',bottom:'13px',right:'0',position:'absolute'}} onClick={this.onModalSettingClick.bind(this)}></span>
            </li>
          )
        } else {
          return(
            <NavItem key={index} eventKey={item.path} disabled={item.disabled!==undefined?item.disabled:false}><FontAwesome name={item.icon} /> {item.title}</NavItem>   
          )
        }         
      })}
      </Nav>
    )
  }

  rendeSettingModal() {
    let {showSetting,loading,settings,roles,role} = this.state
    let default_role = [{label:'ทั้งองค์กร',value:''}]
    let all_roles = default_role.concat(roles)
    return(
          <Modal show={showSetting} enforceFocus={false} onHide={this.onHide.bind(this)}>
            <Modal.Header closeButton>
              <Modal.Title>ตั้งค่าแสดงเมนู/ซ่อนเมนู</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Box loading={loading}>
                <Box.Body>
                <div style={{marginBottom:'5px'}}>
                  <Form inline>
                    <FormGroup>
                      <Select
                        style={{width:'180px'}}
                        clearable={false}
                        value={role}
                        options={all_roles}
                        placeholder='--- เลือกรายการ ---'
                        onChange={this.onRoleChange.bind(this)}
                      />
                    </FormGroup>
                  </Form>
                  </div>
                  <div className='table-responsive'>
                    <table className='table table-hover table-bordered-solid'>
                      <thead>
                        <tr>
                          <th className='text-center' style={{width:'200px'}}>เมนู</th>
                          <th className='text-center' style={{width:'80px'}}>แสดง/ซ่อน</th>
                        </tr>
                      </thead>
                      <tbody>
                        {settings.length===0?<tr><td colSpan={2}>ไม่พบข้อมูล</td></tr>
                        :settings.map((item,index)=>{
                          if (item.key===0||item.key===12||item.key===15) {
                            return(
                              <tr key={index}>
                                <td colSpan={2} style={{backgroundColor:'#a3b9d1',color:'#fff'}}>{item.title}</td>
                              </tr>
                            )
                          } else {
                            return(
                              <tr key={index}>
                                <td>{item.title}</td>
                                <td className='text-center'>
                                  <Checkbox
                                    onChange={this.onSettingMenuCheck.bind(this,index,(item.show?false:true))}
                                    checked={item.show}
                                    checkboxClass="icheckbox_square-blue"
                                    increaseArea="20%"
                                    label=""
                                  />
                                </td> 
                              </tr>
                            )
                          }  
                        })}
                      </tbody>
                    </table>
                  </div>
                </Box.Body>
              </Box>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle='primary' onClick={this.onSettingSaveClick.bind(this)}><FontAwesome name='save' /> บันทึก</Button>
              <Button onClick={this.onHide.bind(this)}><FontAwesome name='close' /> ปิด</Button>
            </Modal.Footer>
          </Modal>        
    )
  }

  render() {
    let {activeKey,perm_settings} = this.state
    return(
  		<Box className='account-settings'>
        <Box.Body>
          <Tab.Container id="tabs-account-settings" activeKey={activeKey} onSelect={this.onTabsSelect.bind(this)}>
            <Row className="clearfix">
              <Col sm={2} style={{maxWidth:'280px'}}>
                {this.renderTabs()}
              </Col>
              <Col sm={10}>
                <Tab.Content animation>
                <Switch>
                  {
                    perm_settings.map((item,index)=>(
                      <Route key={index} exact path={item.path} render={(props) => <Tab.Pane key={index} eventKey={item.path}>{item.content}</Tab.Pane>} />    
                    ))
                  }
                  {perm_settings.length>2?<Route render={(props) => perm_settings[1].content} />:''}
                </Switch>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Box.Body>
        {this.rendeSettingModal()}
        <NotificationSystem ref="notificationSystem" />
  		</Box>
  	)
  }
}
AccountSettings.defaultProps = {
  showAdminMenu:true
}  
 
const mapStateToProps = (state) => ({
  store: state,
  messages: state.message.view.settings.AccountSettings,
});

const _Connect = connect(
    mapStateToProps,
)(AccountSettings);

export default withRouter(_Connect) 



// WEBPACK FOOTER //
// ./src/view/settings/AccountSettings.js